export default {
  freeCase: {
    en: '+ a free case',
  },
}
